/** 数字区间 */
import { FC, useState, useEffect } from 'react';
import { ProInputNumber } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import FormItem from './subpage/formItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { InputNumberProps } from 'antd/lib/input-number';
import { FormItemProps } from 'antd/lib/form';

export interface SearchFormInputIntervalProps extends BaseSearchFormItemProps {
  /** 开始输入框配置 */
  startInputNumberProps?: InputNumberProps;
  /** 结束输入框配置 */
  endInputNumberProps?: InputNumberProps;
  /** 开始表单配置 */
  preFormItemProps?: FormItemProps;
  /** 结束表单配置 */
  afterFormItemProps?: FormItemProps;
  /** 日期之间分隔符  */
  middleText?: string;
  /** 分隔符宽度  */
  middleWidth?: number;
  /** 是否禁用 */
  disabled?: boolean;
}
/** 数字区间 */
export const SearchFormInputInterval: FC<SearchFormInputIntervalProps> = props => {
  const {
    startInputNumberProps,
    endInputNumberProps,
    preFormItemProps,
    afterFormItemProps,
    middleText,
    middleWidth,
    isDetail,
    form,
    isTable,
    testId,
    label,
    company,
    disabled,
    render,
    disabledRender,
    ...resProps
  } = props;
  const [startValue, setStartValue] = useState<number>();
  const [endValue, setEndValue] = useState<number>();
  const startName = preFormItemProps?.name as string;
  const endName = afterFormItemProps?.name as string;
  const required = preFormItemProps?.rules?.some?.((item: any) => item.required);
  const difWidth = Math.floor((middleWidth || 32) / 2);
  useEffect(() => {
    setStartValue(form?.getFieldValue(startName));
    setEndValue(form?.getFieldValue(endName));
  }, [preFormItemProps, afterFormItemProps]);
  const formItemStyle = {
    display: 'inline-block',
    width: `calc(50% - ${difWidth}px)`,
    marginBottom: 0,
    marginRight: 0,
  };
  const handleStartChange = (value: any) => {
    setStartValue(value);
    if (endValue && value < endValue) {
      form?.setFields([
        {
          name: endName,
          errors: [],
        },
      ]);
    }
    startInputNumberProps?.onChange?.(value);
  };
  const handleEndChange = (value: any) => {
    setEndValue(value);
    endInputNumberProps?.onChange?.(value);
  };
  return (
    <SearchFormItem
      {...resProps}
      label={label}
      disabled={isDetail}
      className={required ? 'address-required' : ''}
    >
      {isDetail || disabled ? (
        <SearchFormDisabled
          form={form}
          name={[startName, endName]}
          splitSymbol={middleText}
          company={company}
          isTable={isTable}
          render={render || disabledRender}
        />
      ) : (
        <>
          <FormItem
            style={formItemStyle}
            {...preFormItemProps}
            test-id={`${testId}-${preFormItemProps?.name}`}
            hideLabel={true}
            label={`${label}开始区间`}
            form={form}
          >
            <ProInputNumber
              style={{ width: '100%' }}
              company={company}
              {...startInputNumberProps}
              placeholder={getInputPlaceholder(
                `${label}开始区间`,
                startInputNumberProps,
                preFormItemProps?.rules,
              )}
              onChange={handleStartChange}
            />
          </FormItem>
          <div
            style={{
              display: 'inline-block',
              width: 32,
              height: 28,
              lineHeight: '28px',
              textAlign: 'center',
            }}
          >
            {middleText}
          </div>
          <FormItem
            style={formItemStyle}
            {...afterFormItemProps}
            test-id={`${testId}-${afterFormItemProps?.name}`}
            hideLabel={true}
            label={`${label}结束区间`}
            form={form}
            rules={[
              ...(afterFormItemProps?.rules || []),
              {
                type: 'number',
                min: startValue,
                message: `${label}结束区间不能小于开始区间`,
              },
            ]}
          >
            <ProInputNumber
              style={{ width: '100%' }}
              company={company}
              {...endInputNumberProps}
              placeholder={getInputPlaceholder(
                `${label}结束区间`,
                afterFormItemProps,
                afterFormItemProps?.rules,
              )}
              onChange={handleEndChange}
            />
          </FormItem>
        </>
      )}
    </SearchFormItem>
  );
};

SearchFormInputInterval.defaultProps = {
  middleText: '到',
};
SearchFormInputInterval.displayName =
  SearchFormItemEnum.SearchFormInputInterval;

export default SearchFormInputInterval;
